import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        dark: true,
        themes: {
            dark: {
                primary: '#ffcc66',
                secondary: '#99aabb',
                border: '#696969',
                background: '#272424',
                accent: '#353535',
                error: '#b71c1c',
            }
        }

    },
});
